<div class="gauge-item" [style.background]="corFundo">
    <div class="gauge-item-header">
        <div class="gauge-item-icon-container" [style.background]="corIcone">
            <img [src]="srcIcone" alt="Ícone" class="gauge-item-icon" />
        </div>
        <h3 class="gauge-item-header-meta">{{ meta | arrendondaCasasDecimais : 2 }} HA<span class="asterisco-descricao">*</span></h3>
    </div>
    <h3 class="gauge-item-title">{{ titulo }}</h3>

    <div class="gauge-container">
        <svg class="gauge-svg" width="200" height="140" viewBox="0 0 200 100">
            <path
                d="M151 77C152.657 77 154.006 75.6563 153.942 74.0007C153.587 64.9126 151.625 55.9507 148.139 47.5334C144.269 38.1913 138.597 29.7029 131.447 22.5528C124.297 15.4027 115.809 9.73089 106.467 5.86128C97.1245 1.99166 87.1118 -4.42e-07 77 0C66.8882 4.42e-07 56.8754 1.99166 47.5334 5.86128C38.1913 9.73089 29.7029 15.4027 22.5528 22.5528C15.4027 29.7029 9.73089 38.1913 5.86127 47.5334C2.3747 55.9507 0.41269 64.9126 0.058433 74.0007C-0.00610235 75.6563 1.34315 77 3 77H19.7307C21.3875 77 22.722 75.6558 22.8136 74.0015C23.1512 67.8997 24.5175 61.8912 26.8617 56.232C29.589 49.6478 33.5864 43.6652 38.6258 38.6258C43.6652 33.5864 49.6478 29.589 56.232 26.8617C62.8163 24.1344 69.8732 22.7307 77 22.7307C84.1267 22.7307 91.1837 24.1344 97.768 26.8617C104.352 29.589 110.335 33.5864 115.374 38.6258C120.414 43.6652 124.411 49.6478 127.138 56.232C129.482 61.8912 130.849 67.8997 131.186 74.0015C131.278 75.6558 132.612 77 134.269 77H151Z"
                fill="url(#paint)"
                class="painel-colorido"
            />
            <defs>
                <linearGradient
                    id="paint"
                    x1="0"
                    y1="77"
                    x2="154"
                    y2="77"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#FF5959"/>
                    <stop offset="0.502513" stop-color="#FDF86B"/>
                    <stop offset="1" stop-color="#61D86F"/>
                </linearGradient>
            </defs>

            <polygon
                [attr.transform]="polygonTransform"
                points="100,10 80,90 100,80 120,90"
                fill="black"
                stroke-linecap="round"
                stroke="white"
                stroke-width="2"
                stroke-linejoin="round"
                vector-effect="non-scaling-stroke"
            />
        </svg>

        <div class="gauge-text">
            <h2>{{ real | arrendondaCasasDecimais : 2 }} HA</h2>
        </div>

        <div class="gauge-inicio">
            <h5>0 HA</h5>
        </div>

        <div class="gauge-fim">
            <h5>{{ meta | arrendondaCasasDecimais : 2 }} HA</h5>
        </div>
    </div>
</div>
